export default __webpack_public_path__ + "static/media/power-meter.d12cea17.png";